export enum PeriodTeachingLoadEnum {
    diurnoParcial = 1,
    noturno = 2,
    tempoIntegral = 3
}
